import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface WorkflowDialogData {
  mode: 'validation' | 'status';
  errors?: any[];
  statusOptions?: any[];
}

@Component({
    selector: 'app-common-workflow-dialog',
    templateUrl: './common-workflow-dialog.component.html',
    styleUrls: ['./common-workflow-dialog.component.scss'],
    standalone: false
})
export class CommonWorkflowDialogComponent {

  selectedStatus: string = '';

  constructor(
    public dialogRef: MatDialogRef<CommonWorkflowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkflowDialogData
  ) {}

  confirm() {
    if (this.data.mode === 'status') {
      this.dialogRef.close(this.selectedStatus);
    } else {
      this.dialogRef.close();
    }
  }

  close() {
    this.dialogRef.close();
  }
}